import type React from 'react';
import { cn } from '@/app/utils';

export interface FormItemProps {
  title: string | React.ReactNode;
  required?: boolean;
  content: React.ReactNode;
  contentClassName?: string;
  titleClassName?: string;
}

export const FormItem = ({ title, required = false, content, contentClassName, titleClassName }: FormItemProps) => {
  return (
    <div>
      <div className="mb-1 flex items-center text-xs">
        {required && <span className="mr-1 text-system-danger">*</span>}
        <div className={cn(titleClassName)}>{title}</div>
      </div>
      <div className={cn('rounded-8 bg-system-black36', contentClassName)}>{content}</div>
    </div>
  );
};
